import { startOfHour as startOfHourFns } from 'date-fns';

export default function startOfHour(date: Date): Date {
  return startOfHourFns(date);
}
